import React from "react";
import { Container } from "@mui/material";
import { InfoProductoAdminInicio } from "../../../components/Admin/Inicio/ProductoInicio/ProductoInicio";


export const ProductoInicioAdministrador = () =>{
    return(
        <Container maxWidth='xl'>
            <InfoProductoAdminInicio/>
        </Container>
    )
}